import { FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components';

export const LeftColumn = styled(FlexContainer)`
  flex: 1 1 auto;
`;

export const RightColumn = styled(FlexContainer)`
  width: 40rem;
`;

export const SimpleGraphsContainer = styled(FlexContainer)`
  height: 40rem;
`;
